// extracted by mini-css-extract-plugin
export default {"container":"layoutUnregistered_container__89XDY","background":"layoutUnregistered_background__lCf70","logo":"layoutUnregistered_logo__TJQb3"};